import $ from 'jquery'
import { breakpoints } from './_site'
require('sticky')

let timeout = {}
export const resize = () => {
  var $window = $(window)

  if ($window.width() < breakpoints.lg) {
    // if ($window.width() < breakpoints.sm) {
    sticky(true)
    stickyToggle(true)
    // toggleFilters(true);
  } else {
    sticky(false)
    stickyToggle(false)
    // toggleFilters(false);

    $('.sidebar__item').attr('style', '')

    $('body').removeClass('sidebar-active')
  }
}
export const sticky = (flag) => {
  var $sticky = $('#sticky')
  if (!flag) {
    $sticky.stick_in_parent({
      offset_top: $('#header').outerHeight(),
      // spacer: false
    })
  } else {
    $sticky.trigger('sticky_kit:detach')
    $sticky.off('sticky_kit:bottom')
  }
}
export const toggleFilters = (flag) => {
  var $sidebar = $('#sidebar'),
    $toggles = $sidebar.find('[data-toggle=collapse]'),
    $collapses = $sidebar.find('.collapse')

  if (flag) {
    $toggles.addClass('collapsed')
    $collapses.removeClass('in')
  } else {
    $toggles.removeClass('collapsed')
    $collapses.addClass('in')
  }
}
export const stickyToggle = (flag) => {
  var $sticky = $('.sidebar__toggle')
  if (!flag) {
    $sticky.stick_in_parent({
      offset_top: 300,
      // spacer: false
    })
  } else {
    $sticky.trigger('sticky_kit:detach')
    $sticky.off('sticky_kit:bottom')
  }
}
export const toggle = ($el) => {
  var data = $el.data('sidebar-toggle'),
    $target

  if ($el.length) {
    $target = $(data).add('.fixed')
    $target.show()
    // $target.siblings().not($target).hide();
    // $('.sidebar__item').not($target).hide();
  }

  $('body').toggleClass('sidebar-active')
}
export const binds = ($el) => {
  // ---------------- recalc sidebar height
  $('.sidebar').on('hidden.bs.collapse shown.bs.collapse', '.collapse', function () {
    $(document.body).trigger('sticky_kit:recalc')
  })

  // ---------------- toggle
  $('body').on('click.sidebar', '[data-sidebar-toggle]', function (event) {
    event.preventDefault()
    toggle($(this))
  })

  /// ---------------- window events
  $(window).on('resize.sidebar', function () {
    clearTimeout(timeout.sidebar)
    timeout.sidebar = setTimeout(function () {
      resize()
    }, 100)
  })
  $(window).triggerHandler('resize.sidebar')
}
